import { ComposableFunctionArgs } from '~/composables/types';
import { Logger } from '~/helpers/logger';
import { Cart } from '~/modules/GraphQL/types';
import { VsfContext } from '~/composables/context';
import GET_CART from '~/modules/checkout/composables/useCart/getCart.gql'
import GET_CUSTOMER_CART from '~/modules/checkout/composables/useCart/getCustomerCart.gql'


export const loadCartCommand = {
  execute: async (context: VsfContext, params: ComposableFunctionArgs<{
    realCart?: boolean;
    newCart?: boolean;
  }>) => {
    const apiState = context.$magento.config.state;
    Logger.debug('[Magento Storefront]: Loading Cart');
    const customerToken = apiState.getCustomerToken();

    const virtual = !params.realCart;
    const generateNewCart = params.newCart;

    const createVirtualCart = () => (null as Cart);

    const createRealCart = async (): Promise<string> => {
      Logger.debug('[Magento Storefront]: useCart.load.createNewCart');

      apiState.setCartId();

      const { data } = await context.$magento.api.createEmptyCart();
      Logger.debug('[Result]:', { data });

      apiState.setCartId(data.createEmptyCart);

      return data.createEmptyCart;
    };

    const getCartData = async (id: string) => {
      Logger.debug('[Magento Storefront]: useCart.load.getCartData ID->', id);

      const { data, errors } = await context.$magento.api.cart(id);
      Logger.debug('[Result]:', { data });

      if (!data?.cart && errors?.length) {
        throw errors[0];
      }

      data.cart.items = data.cart.items.filter(Boolean);
      return data.cart as unknown as Cart;
    };

    const getCart = async (virtualCart: boolean, cartId?: string, newCart?: boolean) => {

      // Condition used to force new cart generation:
      if (newCart) {
        cartId = await createRealCart();
        apiState.setCartId(cartId);
        return getCartData(cartId);
      }


      if (!cartId) {
        if (virtualCart) {
          return createVirtualCart();
        }

        // eslint-disable-next-line no-param-reassign
        cartId = await createRealCart();
        apiState.setCartId(cartId);
      }

      return getCartData(cartId);
    };
    // Try to load cart for existing customer, clean customer token if not possible
    if (customerToken) {
      try {
        const cart = await context.$magento.api.customQuery({ query: GET_CUSTOMER_CART, customHeaders: { "Authorization": "Bearer " + customerToken } }) as any;
        const cartId = cart.data.customerCart.id;
        const { data: respData, errors } = await context.$magento.api.customQuery({ query: GET_CART, queryVariables: { cartId } })
        const data = { customerCart : (respData as any).cart as Cart}
        Logger.debug('[Result]:', { data, errors });

        if (!data?.customerCart && errors?.length) {
          throw errors[0];
        }

        apiState.setCartId(data.customerCart.id);
        data.customerCart.items = data.customerCart.items.filter(Boolean);

        return data.customerCart as unknown as Cart;
      } catch (er){
      Logger.debug('[Error]:', { error: er });
        apiState.setCustomerToken();
      }
    }

    try {
      // If it's not existing customer check if cart id is set and try to load it
      let cartId = apiState.getCartId();
 
      return await getCart(virtual, cartId, generateNewCart);
    } catch {
      apiState.setCartId();
      return await getCart(virtual);
    }
  },
};
